<template>
  <q-select
    ref="select"
    v-bind="$attrs"
    :value="model"
    :options="filteredOptions"
    :outlined="outlined"
    :stack-label="stackLabel"
    :emit-value="emitValue"
    :hide-selected="hideSelected"
    :use-input="filter"
    :input-debounce="debounce"
    v-on="$listeners"
    @filter="filterFn"
    @focus="highlightFirst"
  >
    <template #no-option>
      <q-item>
        <q-item-section class="text-grey">
          No results
        </q-item-section>
      </q-item>
    </template>

    <template v-for="(fn, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="props">
      <slot :props="props" :name="scopedSlotName" />
    </template>

    <!--https://gist.github.com/Loilo/73c55ed04917ecf5d682ec70a2a1b8e2-->
    <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
  </q-select>
</template>

<script>
export default {
  name: 'EnhancedQSelect',
  inheritAttrs: false,
  props: {
    id: [Number, String],
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    value: [Number, Object, String, Array, Boolean],
    outlined: {
      type: Boolean,
      default: true
    },
    stackLabel: {
      type: Boolean
    },
    emitValue: {
      type: Boolean,
      default: true
    },
    filter: {
      type: Boolean,
      default: true
    },
    debounce: {
      type: [String, Number],
      default: 0
    },
    hideSelected: Boolean
  },
  data() {
    return {
      terms: null,
      model: null,
      filteredOptions: [],
      highlightFirstTimer: null
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) this.setModel(newVal)
    },
    options: {
      handler(val) {
        this.filteredOptions = [...val]
        this.setModel(this.value)
      },
      immediate: true
    }
  },
  beforeDestroy() {
    clearTimeout(this.highlightFirstTimer)
  },
  methods: {
    setModel(val) {
      const option = this.options.find(x => x.value === val)
      if (!option) this.model = null
      else this.model = { label: option.label, value: option.value }
    },
    filterFn(terms, update) {
      update(() => {
        let results = this.options.filter(option => option.label.toLowerCase().indexOf(terms.toLowerCase()) !== -1)
        // Account for quasar retuning the item itself if only 1 found
        this.filteredOptions = results ? (Array.isArray(results) ? results : new Array(results)) : []
        this.highlightFirst()
        this.$emit('set-entity-name', terms)
      })
    },
    highlightFirst() {
      if (this.filteredOptions.length) {
        this.highlightFirstTimer = setTimeout(() => {
          this.$refs.select.setOptionIndex(0)
        }, 1)
      }
    }
  }
}
</script>

<style lang="stylus">
.tooltip-indicator {
  position: absolute;
  right: 6px;
  top: 10px;
}
</style>
